import { PageHeader } from '@/components/molecules';
import { StoreBuilderForm } from './components';

export const StoreBuilderPage = () => {
  return (
    <div className="flex flex-col gap-12">
      <PageHeader
        heading="Store Builder"
        description="Follow this steps to create your store in 2 minutes"
      />
      <StoreBuilderForm />
    </div>
  );
};
